import { createStore, Event } from 'effector';

import { applyReducers } from '@m/effector-utils';
import { logout } from 'apps/customer/state/user';

import { setFromSms, setPromoShortCode } from './actions';

type PromoState = {
  fromSms: boolean;
  savedShortCode: string;
};

const initialState: PromoState = {
  savedShortCode: '',
  fromSms: false,
};

const store = createStore(initialState);

type Reducers = {
  setFromSms: {
    action: Event<boolean>;
    reducer: (state: PromoState, payload: boolean) => PromoState;
  };
  setPromoShortCode: {
    action: Event<string>;
    reducer: (state: PromoState, payload: string) => PromoState;
  };
};

export const reducers: Reducers = {
  setPromoShortCode: {
    action: setPromoShortCode,
    reducer: (state, payload) => ({
      ...state,
      savedShortCode: payload,
    }),
  },
  setFromSms: {
    action: setFromSms,
    reducer: (state, payload) => ({
      ...state,
      fromSms: payload,
    }),
  },
};

store.reset(logout.done);

export default applyReducers({ store, reducers });
